import React from 'react'
import { Stamp, Text } from './style'

export default () =>
    <Stamp>
        <Text>Transação via</Text>
    </Stamp>
